import { render, staticRenderFns } from "./fission-campagin-edit.vue?vue&type=template&id=803664d6&scoped=true&"
import script from "./fission-campagin-edit.vue?vue&type=script&lang=ts&"
export * from "./fission-campagin-edit.vue?vue&type=script&lang=ts&"
import style0 from "./fission-campagin-edit.vue?vue&type=style&index=0&id=803664d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803664d6",
  null
  
)

export default component.exports